import { Heart } from 'lucide-react'
import { ModalOverlay } from './ModalOverlay'
import { Character } from '../Character'

const F = 'Roboto, sans-serif'

interface Props {
  open: boolean
  onClose: () => void
  livesRemaining?: number
}

export function LifeLostModal({ open, onClose, livesRemaining = 2 }: Props) {
  return (
    <ModalOverlay open={open} onClose={onClose} borderColor="#FF3B30">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontFamily: F, gap: 12 }}>
        <Character stage={1} mood="SAD" size={120} animated={false} />
        <h2 style={{ fontSize: 20, fontWeight: 600, color: '#1C2D41', margin: 0, textAlign: 'center' }}>Ты потерял жизнь</h2>
        <div style={{ display: 'flex', gap: 6 }}>
          {Array.from({ length: 3 }, (_, i) => (
            <Heart key={i} size={28} color={i < livesRemaining ? '#FF3B30' : '#CBD5E0'} fill={i < livesRemaining ? '#FF3B30' : '#CBD5E0'} />
          ))}
        </div>
        <p style={{ fontSize: 15, color: '#6B7B8D', margin: 0, textAlign: 'center', lineHeight: 1.5 }}>
          Осталось {livesRemaining} жизни. Вернись к заданиям!
        </p>
        <button onClick={onClose} style={{ width: '100%', height: 52, borderRadius: 16, border: 'none', background: 'linear-gradient(135deg, #1A3A5C, #4A6CF7)', color: 'white', fontSize: 16, fontWeight: 700, cursor: 'pointer', fontFamily: F, marginTop: 8 }}>
          Вернуться к заданиям
        </button>
      </div>
    </ModalOverlay>
  )
}
